export default __webpack_public_path__ + "910732b3dd8a21b8356eacea032fc926.png";